export default __webpack_public_path__ + "images/OI.27b6cba.png";